import { render } from "./meusAtendimentos.vue?vue&type=template&id=2ed0ecb5&scoped=true"
import script from "./meusAtendimentos.vue?vue&type=script&lang=js"
export * from "./meusAtendimentos.vue?vue&type=script&lang=js"

import "./meusAtendimentos.vue?vue&type=style&index=0&id=2ed0ecb5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ed0ecb5"]])

export default __exports__